<div class="settings-row">
    <slot />
</div>

<style>
    .settings-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /*padding: 10px 0;*/
        /*border-bottom: 1px solid #e0e0e0;*/
        column-gap: 10px;
        margin: 2px 0;
    }
</style>
